<template>
  <v-container fluid>
    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="true"
        :addItem="false"
        @loggedIn="signupDialog = false"
        :fromPage="true"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
      >
        <v-icon @click="signupDialog = false" class="exit">mdi-close</v-icon>
      </SignupComponent>
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="false"
        :fromPage="true"
        :addItem="false"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>
    <div class="landing-page">
      <div class="background-container grid">
        <div class="gradient-overlay"></div>
        <v-container fluid class="content-container">
          <v-row justify="center" align="center">
            <v-col cols="11" sm="8" md="6" class="grid mt-n3">
              <v-img
                height="20vh"
                width="20vh"
                :src="require('@/assets/logos/logo-white.svg')"
              />

              <h1 class="text-center white--text">
                Sign Up to Airbnb meets eBay for second-hand tech products
              </h1>
              <br />
              <p class="text-center white--text">
                Discover a thriving community-driven second-hand marketplace for
                electronic products that empowers you to securely and
                effortlessly buy, sell, or rent pre-loved gear within your local
                community. Enjoy the added convenience of Try-Before-You-Buy and
                connect with like-minded individuals sharing their high-quality
                second-hand items.
                <br />
                <br />
                <!-- <a class="white--text">Learn more</a> -->
                <br />
                <br />
                <v-btn
                  @click.stop="signupDialog = true"
                  x-large
                  style="border-radius: 10px"
                  class="app--text mb-7"
                  elevation="0"
                  >Sign Up
                  <v-img
                    class="ml-3"
                    :src="
                      require('@/assets/fontawesome/user-plus-duotone2.svg')
                    "
                  />
                </v-btn>
              </p>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "StrappLanding",

  components: {
    SignupComponent: () => import("@/components/Auth/Signup"),
    LoginComponent: () => import("@/components/Auth/Login"),
  },

  data() {
    return {
      signupDialog: false,
      loginDialog: false,
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.background-container {
  background-image: url("../assets/landing/landing.png");
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}
.gradient-overlay {
  position: absolute;
  width: 870px;
  height: 549px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background: radial-gradient(
    50% 50% at 50% 50%,
    #8531a9 65.87%,
    rgba(133, 49, 169, 0) 100%
  );
}

.content-container {
  position: relative;
  z-index: 2;
  padding-top: 25vh;
  padding-bottom: 100px;
}

.icon-row {
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.icon-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  flex-basis: calc(25% - 40px);
  margin-bottom: 20px;
}
</style>
